import React, { useState } from "react";
import { MessageSquare } from "lucide-react";
import DossierDiscussion from "../DossierDiscussion";
import { Avatar } from "./TicketMembers";

const rel = (iso) => {
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "à l'instant";
  if (m < 60) return `il y a ${m} min`;
  if (m < 1440) return `il y a ${Math.round(m / 60)} h`;
  return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export function TicketActivity({ ticket, entityType }) {
  const [details, setDetails] = useState(true);
  const acts = [...(ticket.activity || [])].reverse();
  return (
    <div className="flex flex-col gap-4" data-testid="trello-activity">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-semibold text-norea-text"><MessageSquare className="w-4 h-4" /> Commentaires et activité</div>
        <button onClick={() => setDetails(!details)} className="btn-secondary text-xs" data-testid="trello-activity-toggle">{details ? "Masquer les détails" : "Afficher les détails"}</button>
      </div>
      <DossierDiscussion dossierId={ticket.id} entityType={entityType} />
      {details && (
        <ul className="space-y-3" data-testid="trello-activity-list">
          {acts.map((a) => (
            <li key={a.id} className="flex items-start gap-2.5 text-sm">
              <Avatar email={a.user_email} name={a.user_name} size="w-7 h-7 text-[10px]" />
              <div className="min-w-0">
                <span className="font-semibold text-norea-text">{a.user_name}</span> <span className="text-norea-text">{a.text}</span>
                <div className="text-[11px] text-norea-textMuted">{rel(a.at)}</div>
              </div>
            </li>
          ))}
          {acts.length === 0 && <li className="text-xs text-norea-textMuted italic">Aucune activité</li>}
        </ul>
      )}
    </div>
  );
}
